import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const PREVIEW_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/kTd1ETu7a1CKzMRNvo8es2/Error-1-Lo-lleno-porque-asi-termino-antes.png',
  alt: 'Página del Tomo 1 — Errores comunes con la Airfryer',
  label: 'Tomo 1 — Errores comunes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/e4wBVQHX9ezeh8prtnhr63/Semanas-1-y-2-Express-Anti-delivery.png',
  alt: 'Menú semanal Express Anti-delivery',
  label: 'Bono — Menú semanal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pTX7aZDVQc6fCFfawtHZ2d/8-Albondigas-Glaseadas-BBQ.png',
  alt: 'Receta de Albóndigas Glaseadas BBQ',
  label: 'Receta — Albóndigas BBQ'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x451JdyVvWcaDuntpYxQAy/4-Muslos-Dorados-al-Pimenton.png',
  alt: 'Receta de Muslos Dorados al Pimentón',
  label: 'Receta — Muslos al Pimentón'
}];
interface ProductCarouselProps {
  onImageClick?: () => void;
}
export function ProductCarousel({
  onImageClick
}: ProductCarouselProps) {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 400);
  }, [isTransitioning]);
  const next = useCallback(() => {
    goTo((current + 1) % PREVIEW_IMAGES.length);
  }, [current, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + PREVIEW_IMAGES.length) % PREVIEW_IMAGES.length);
  }, [current, goTo]);
  // Auto-advance every 4 seconds
  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);
  return <div className="relative max-w-2xl mx-auto" data-id="element-266">
      {/* Main image container */}
      <div className="relative overflow-hidden rounded-2xl shadow-2xl bg-white border border-gray-200" data-id="element-267">
        <div className="flex transition-transform duration-400 ease-in-out" style={{
        transform: `translateX(-${current * 100}%)`
      }} data-id="element-268">
          {PREVIEW_IMAGES.map((img, i) => <div key={i} className="w-full flex-shrink-0" data-id="element-269">
              <img src={img.src} alt={img.alt} className="w-full h-auto cursor-pointer" onClick={onImageClick} data-id="element-270" />
            </div>)}
        </div>

        {/* Navigation arrows */}
        <button onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-lg hover:bg-white transition-colors z-10" aria-label="Anterior" data-id="element-271">
          <ChevronLeft className="w-5 h-5 text-gray-700" data-id="element-272" />
        </button>
        <button onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-lg hover:bg-white transition-colors z-10" aria-label="Siguiente" data-id="element-273">
          <ChevronRight className="w-5 h-5 text-gray-700" data-id="element-274" />
        </button>
      </div>

      {/* Label */}
      <p className="text-center mt-4 text-gray-600 font-semibold text-sm" data-id="element-275">
        {PREVIEW_IMAGES[current].label}
      </p>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-3" data-id="element-276">
        {PREVIEW_IMAGES.map((_, i) => <button key={i} onClick={() => goTo(i)} className={`w-3 h-3 rounded-full transition-all duration-300 ${i === current ? 'bg-yellow-500 scale-125' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-277" />)}
      </div>

      {/* Page counter */}
      <p className="text-center mt-2 text-xs text-gray-400" data-id="element-278">
        {current + 1} / {PREVIEW_IMAGES.length}
      </p>
    </div>;
}